(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ai-assistant-monitoring', {
            parent: 'entity',
            url: '/ai-assistant-monitoring',
            data: {
                authorities: ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'],
                pageTitle: 'wamasysApp.aiAssistantMonitoring.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/ai-assistant-monitoring/ai-assistant-monitoring.html',
                    controller: 'AiAssistantMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aiAssistantMonitoring');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ai-assistant-system-commands', {
            parent: 'entity',
            url: '/ai-assistant-monitoring/system-commands',
            data: {
                authorities: ['ROLE_SUPER_ADMIN'],
                pageTitle: 'Commandes systeme assistant IA'
            },
            views: {
                'content@': {
                    templateUrl: 'app/business/ai-assistant-monitoring/ai-assistant-system-commands.html',
                    controller: 'AiAssistantSystemCommandsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aiAssistantMonitoring');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
